import React, { useEffect, useState } from 'react';
import { SupportService } from '../../services';
import { toast } from 'react-toastify';
import { Box, Typography, Grid, Paper, Link, Skeleton } from '@mui/material';
import chatEmailImg from "../../images/chatEmailImg.png";
import chatCallImg from "../../images/chatCallImg.png";

export const CustomerCare = () => {
    const [customerCare, setCustomerCare] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCustomerCare = async () => {
            try {
                const data = await SupportService.getCustomerCare();
                setCustomerCare(data.data);
            } catch (error) {
                toast.error(error.response.data.message);
            } finally {
                setLoading(false);
            }
        };
        fetchCustomerCare();
    }, []);

    return (
        <section className="col-lg-9 col-12">
            <Box sx={{ padding: 2 }}>
                <div className="basicDetailTlt">
                    <p className="helpStitle">Customer Care</p>
                </div>
                <Grid container spacing={2} justifyContent="center">
                    {/* Email Block */}
                    {loading ? (
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper elevation={3} sx={{ padding: 2, textAlign: 'center' }}>
                                <Skeleton variant="text" width="60%" sx={{ marginBottom: 2 }} />
                                <Skeleton variant="rectangular" width="50px" height="50px" sx={{ marginBottom: 2 }} />
                                <Skeleton variant="text" width="80%" sx={{ marginBottom: 1 }} />
                                <Skeleton variant="text" width="60%" />
                            </Paper>
                        </Grid>
                    ) : (
                        <Grid item xs={12} sm={6} md={4}>
                            <Paper elevation={3} sx={{ padding: 2, textAlign: 'center' }}>
                                <Typography variant="h6" gutterBottom>Email Address</Typography>
                                <Box sx={{ marginBottom: 2 }}>
                                    <img src={chatEmailImg} alt="Email" style={{ width: 50, height: 50 }} />
                                </Box>
                                <Link href="mailto:info@indmatrimony.com" variant="body1" color="primary">
                                    info@indmatrimony.in
                                </Link>
                                <Typography variant="body2" sx={{ marginTop: 1 }}>
                                    Submit a request
                                </Typography>
                            </Paper>
                        </Grid>
                    )}

                    {loading ? (
                        [1, 2, 3].map((_, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Paper elevation={3} sx={{ padding: 2, textAlign: 'center' }}>
                                    <Skeleton variant="text" width="80%" sx={{ marginBottom: 2 }} />
                                    <Skeleton variant="rectangular" width="50px" height="50px" sx={{ marginBottom: 2 }} />
                                    <Skeleton variant="text" width="60%" />
                                    <Skeleton variant="text" width="70%" />
                                </Paper>
                            </Grid>
                        ))
                    ) : (

                        customerCare.length === 0 ? (
                            <Typography variant="body1" sx={{ marginTop: 2 }} align="center">
                                No customer care details found.
                            </Typography>
                        ) : (
                            customerCare.map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Paper elevation={3} sx={{ padding: 2, textAlign: 'center' }}>
                                        <Typography variant="h6" gutterBottom>{item.number_type}</Typography>
                                        <Box sx={{ marginBottom: 2 }}>
                                            <img src={chatCallImg} alt="Call" style={{ width: 50, height: 50 }} />
                                        </Box>
                                        <Typography variant="body1">{item.mobile_no}</Typography>
                                        <Typography variant="body2" sx={{ marginTop: 1 }}>
                                            Call Us between 10am - 7pm (IST)
                                        </Typography>
                                    </Paper>
                                </Grid>
                            ))
                        )
                    )}

                </Grid>
            </Box>
        </section>
    );
};
